import { usePostApiNotificationsReadAll, } from '../../generated/sitComponents';
import { sortNotificationsDesc } from './helpers';
import { getNotificationQueryKey } from './query-key';
export function usePostNotificationsReadAll(options) {
    return usePostApiNotificationsReadAll({
        ...options,
        onMutate: async (variables, context) => {
            await context.client.cancelQueries({ queryKey: getNotificationQueryKey });
            // Snapshot the previous value
            const queryData = context.client.getQueryData(getNotificationQueryKey);
            context.client.setQueryData(getNotificationQueryKey, queryData?.map((notification) => ({
                ...notification,
                read: true,
            })));
            options?.onMutate?.(variables, context);
            return {
                queryData,
            };
        },
        onError: (error, variables, onMutateResult, context) => {
            context.client.setQueryData(getNotificationQueryKey, onMutateResult.queryData);
            options?.onError?.(error, variables, onMutateResult, context);
        },
        onSuccess: (data, variables, onMutateResult, context) => {
            context.client.setQueryData(getNotificationQueryKey, sortNotificationsDesc(data));
            options?.onSuccess?.(data, variables, onMutateResult, context);
        },
    });
}
//# sourceMappingURL=use-post-notifications-read-all.js.map